
export const bullet = ({ primary, secondary }) => {
  return {
    color: `rgba(${primary}, 1)`,
  }
};